<template>
    <div v-if="breadcrumb" class="max-w-[1408px] mx-auto">
        <LayoutBreadcrumb :breadcrumb="breadcrumb" />
    </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import type { HblBreadcrumb, HblSlot } from '@/utils/types'

const props = defineProps<{
    content: HblSlot
}>()

const breadcrumb = inject<HblBreadcrumb>('hblBreadcrumbData')
</script>
